export default [
  {
    path: '/landing',
    meta: {
      title: 'Document Verification',
    },
    component: () => import('@/modules/common/views/Public.vue'),
    children: [].concat({
      name: 'LandingValidation',
      path: 'validation/:document_unique_key',
      meta: {
        title: 'Document',
      },
      component: () => import('@/modules/validate_landing/views/ValidateLanding.vue'),
    }),
  },
];
